"use client"; 

import { useEffect } from 'react';
import { useError } from '@/context/ErrorContext';

const GlobalErrorHandler = () => {
  const { showError } = useError();

  useEffect(() => {
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('Unhandled promise rejection:', event.reason);
      showError(event.reason?.message || 'An unexpected error occurred');
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, [showError]);

  return null;
};

export default GlobalErrorHandler;
